// extracted by mini-css-extract-plugin
export default {"conversations-list":"ConversationsList_conversations-list__2tlHc","conversations-list--no-messages":"ConversationsList_conversations-list--no-messages__4ieZ2"};